module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor_/oil_valve_256_bake.png";